module.exports = __webpack_public_path__ + "img/candidate-orange.ac89419f.png";